import { useOrderMovements } from '@/api/useOrderMovements'
import type { components } from '@/types/api/v1'
import { useCallback } from 'react'
import { useEbolMatchingContext } from '../../../EbolMatchingContext'

type Field = components['schemas']['MappingField']
export const useAddCellMapping = (field: Field, sourceSystem: string, sourceId?: string) => {
  const { match } = useEbolMatchingContext()
  const { useAddEbolMapping } = useOrderMovements()
  const { mutateAsync } = useAddEbolMapping()

  return useCallback(
    (name: string) => {
      if (!sourceId) {
        console.error('Source ID is required for mapping')
        return
      }
      mutateAsync({
        body: {
          field,
          name,
          source_id: sourceId,
          source_system: sourceSystem,
        },
      }).then((result) => {
        if (result.auto_match_occurred) {
          match()
        }
      })
    },
    [field, match, mutateAsync, sourceId, sourceSystem]
  )
}
